import { useEffect, useState } from "react";
import SyIcon from "../../../../../shared/components/sy-icon";
import SyOverlayContainer from "../../../../../shared/components/sy-overlay-container";
import styleSheet from "../style.module.scss";
import FilesCommentsManage from "../../../components/files-comments-manage";
import { Canvas } from "@react-three/fiber";
import { useDispatch, useSelector } from "react-redux";
import {
  getCommunityDetails,
  setDoc,
  setTimeLine,
} from "../../../../../feature/community-slice/community-slice";
import OrbMap from "../../../../../shared/components/orb-map";
import PlanetActionManage from "../../../components/planet-engage/planet-engage";
import CommunityManage from "../community-manage";
import { useMutation } from "@tanstack/react-query";
import citizenService from "../../../services/citizen-service";
import { useParams } from "react-router";

import { getAuthDetails } from "../../../../../feature/auth-slice";
import FireworksCanvas from "../../../../../shared/components/ob-fire/ob-fire-animated";
import CommunityUpdateManage from "../community-updates-magement";
import {
  communityParamPayload,
  setQueryParams,
} from "../../../../../utils/helper";
import { getOrbitDetails } from "../../../../../feature/orbit-slice";
import { getPlanetDetails } from "../../../../../feature/planet-slice";

const CommunityDetails = (props: any) => {
  const { timeLineData, updatePlanet, onClose } =
    props;
  const {planetData,planetStatus,planetAccess} = useSelector(getPlanetDetails);

  const [engage, setEngage] = useState<boolean>(false);
  const authDetails = useSelector(getAuthDetails);
  const { orbitId, planetId } = useParams();
  const [citizensData, setCitizensData] = useState<any>([]);
  const dispatch = useDispatch();
  const orbitSlice = useSelector(getOrbitDetails);
  const [mode, setMode] = useState<"heal" | "engage">();
  const [close, setClose] = useState<boolean>(true);
  const [like, setLike] = useState<boolean>(false);
  const [showMap, setShowMap] = useState(false);
  const communityDetail = useSelector(getCommunityDetails);
  const [location, setLocation] = useState([]);

  const onClickClose = () => {
    setClose(false);
    onClose();
  };

  const onEngage = () => {
    setEngage(true);
    setMode("engage");

  };

  const onLike = (val: any) => {
    setLike(val);
  };
  const onHeal = () => {
    setEngage(true);
    setMode("heal");
  };

  const onClickEngage = () => {
    onEngage();
  };
  const onClickHeal = () => {
    onHeal();
  };

  const onCitizenInvite = () => {
    getCitizenData();
  };

  const updateData = (timeline:any) => {
    if(timeline){
 updatePlanet("timeLine");
    }else{
       updatePlanet();
    }
   
  };

  const onActionEnd = () => {
    setEngage(false);
    setMode(undefined);
  };

  const clickLocation = () => {
    const address: any = [
      {
        id: planetData.images[0].id,
        address: planetData.pro_address,
        hover: true,
        pro_id: planetData.pro_id,
        orb_id: Number(orbitId),
      },
    ];
    setLocation(address);
    setShowMap(!showMap);
  };

  const getCitizenData = () => {
    const payload = {
      pro_id: planetId,
    };
    getInvitCitizenList(payload);
  };

  const { mutate: getInvitCitizenList } = useMutation({
    mutationFn: citizenService.getInvitCitizenList,
    onSuccess(data, variables, context) {
      setCitizensData(data.data);
      updatePlanet();
    },
  });

  const timeLine = () => {
    dispatch(setTimeLine(!communityDetail.timeLine));
    setQueryParams(
      communityParamPayload(!communityDetail.timeLine, communityDetail.doc)
    );
  };
  const doc = () => {
    dispatch(setDoc(!communityDetail.doc));
    setQueryParams(
      communityParamPayload(communityDetail.timeLine, !communityDetail.doc)
    );
  };

  useEffect(() => {

    if ([1, 2, 3].includes(planetAccess)) {
      doc();
    }
  }, [planetAccess]);

  return (
    <>
      <div className=" h-100 " onClick={onClickClose}>
        <div
          className={` position-absolute bottom-0 px-4 w-100  `}
          onClick={(e) => e.stopPropagation()}
        >
          <SyOverlayContainer
            open={close}
            background="dark-transparent"
            height="full"
          >
            <>
              <div className="d-flex justify-content-end pe-2 pt-2 pointer text-disabled position-sticky ">
                <SyIcon name={"close"} onClick={onClickClose} />
              </div>
              <div
                className={`d-flex flex-wrap flex-row h-100 p-3  sy-scroll-y   `}
              >
                <div className={`col-lg-7 col-sm-12  pb-3 `}>
                  {planetData && planetStatus && (
                    <>
                      <CommunityManage
                        onEngage={onClickEngage}
                        onHeal={onClickHeal}
                        onCitizenInvite={onCitizenInvite}
                        onLike={onLike}
                        updatePlanet={updatePlanet}
                        timeLineData={timeLineData}
                      />

                      <div className="">
                        <CommunityUpdateManage
                          timeLine={timeLine}
                          doc={doc}
                        
                          timeLineData={timeLineData}
                          updatePlanet={updatePlanet}
                        />
                      </div>
                    </>
                  )}
                </div>

                <div
                  className={` col-lg-5 col-sm-12 position-sticky sy-scroll-y h-100  top-0   ${styleSheet.rtf_component}`}
                >
                  {communityDetail.doc &&
                  (planetData?.isAdmin ||
                    planetAccess === 1 ||
                    planetAccess == 2 ||
                    planetAccess == 3) ? (
                    <div className={` position-absolute  z-3`}>
                      <FilesCommentsManage
                        updateData={updateData}
                        getCitizenData={getCitizenData}
                        citizensData={citizensData}
                      />
                    </div>
                  ) : null}

                  {like && !showMap ? (
                    <div
                      className={`${styleSheet.like} position-absolute mt-4 `}
                    >
                      <FireworksCanvas width={650} height={600} active={like} />
                    </div>
                  ) : null}
                  {!showMap && (
                    <Canvas className={` position-relative`}>
                      <PlanetActionManage
                        engage={engage}
                        mode={mode}
                        onEngaged={onActionEnd}
                        clickLocation={clickLocation}
                        planetDetails={planetData}
                      />
                    </Canvas>
                  )}
                  {showMap && (
                    <div className={`${styleSheet.map} mb-2`}>
                      <div className="d-flex justify-content-end">
                        <SyIcon
                          name={"close"}
                          iconColor="rgba(255, 255, 255, 0.3)"
                          onClick={clickLocation}
                          className={`  pointer  `}
                        />
                      </div>
                      <div className="col z-2">
                        <OrbMap locations={location} />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          </SyOverlayContainer>
        </div>
      </div>
    </>
  );
};

export default CommunityDetails;
